export interface IWeatherLinkStation {
  weatherLinkStationId: number
  name: string
  location: string
  sourceName: string
}

export interface Interface {
  id: string
  interface_name: string
  interfaceCustomName: string
  organizations: { id: number; name: string; description: string }[]
  weatherLinkStation: {
    weatherLinkStationId: number
    name: string
    location: string
    sourceName: string
  }[]
  isParent: string
  interface_id: string
  parent_interface: string
  users_staff: string
}

export interface Country {
  id: number
  iso: string
  iso3: string
  isoNumeric: string
  fips: string
  name: string
}
export interface Sensor {
  numberOfSensors: number
  type: number
  typeName: string
}
export interface SensorInterface {
  id: number
  sensorRef: number
  stationRef: number
  weatherStationName: string | null
  sensorIdentifier: string
  name: string
  nodeName: string
  type: number
  typeName: string
  isAssigned: boolean
  sensors: Sensor[]
}

export interface InterfaceID {
  id: number
  organizationId?: string
  listOrganizationId: number[]
  name: string
  pictureUrl: string
  pictureFileName: string
  weatherLinkStationIds: number[] | null
  customName: string
  countryId: number
  timeZoneId: number
  isObservedDst: boolean
}

export interface ResetLineUnits {
  interfaceId: number
  verificationToken: string
}

export interface IInterfaceByIdResponse {
  id: number
  name: string
  customName: string
  organizationId: number[]
  pictureUrl: string
  pictureFileName: string
  weatherLinkStations: IWeatherLinkStation[] | null
  updatedAt: string
  countryId: string
  countryName: string
  timeZoneId: string
  timeZone: string
  timeZoneName: string
  timeZoneOriginId: string
  isObservedDst: boolean
  state: string
  status: boolean
  softWareVersion: number
  type: InterfaceType
}

export interface ISearchInterfaceItem {
  id: string | number
  interface_name: string
  organizations: Array<{
    id: number
    name: string
    description: string
  }>
  weatherLinkStation: Array<{
    weatherLinkStationId: number
    name: string
    location: string
    sourceName: string
  }>
  status: boolean
  updated_at: string
  created_at: string
  state: string
  timeZone: string
  interfaceCustomName: string
  country: {
    id: number
    iso: string
    iso3: string
    isoNumeric: string
    fips: string
    name: string
  }
  timeZoneName: string
  customName: string
  name: string
}

export enum InterfaceType {
  CONTROL_HUB = 4,
}

export interface InterfaceBackupLogUser {
  id: number
  name: string
  email: string
  status: boolean
}

export enum InterfaceBackupStatus {
  InProgress = 10,
  Failed = 20,
  Completed = 30,
}

export enum InterfaceBackupLogType {
  Backup = 10,
  Restore = 20,
}

export interface InterfaceBackupLog {
  status: InterfaceBackupStatus
  type: InterfaceBackupLogType
  logTime: string
  message: string
  user: InterfaceBackupLogUser | null
}

export interface InterfaceBackup {
  id: number
  interfaceId: number
  name: string
  fileName: string
  filePath: string
  fileSize: number
  createdAt: string
  latestStatus: InterfaceBackupStatus
  logs: InterfaceBackupLog[]
}

export enum InterfaceState {
  ONLINE = 'Online',
  OFFLINE = 'Offline',
}
